
/*For navbar back to all events interaction/button */
jQuery(document).ready(function() {
	jQuery(".dcl__topbar--registration").hover(function(e) {
	      jQuery('.all__events--btn').toggle("fast");
		  e.preventDefault();
	});
});

jQuery(document).ready(function() {
	jQuery(".page-template-template-event-conference .conference__topbar").hover(function(e) {
	      jQuery('.all__events--btn').toggle("fast");
		  e.preventDefault();
	});
});
/*For navbar back to all events interaction/button */

/*
jQuery(window).scroll(function() {
  jQuery('.pc__sticky').stop(true, true).hide().fadeIn('slow');
});
*/

jQuery(document).scroll(function() {
	jQuery('.pc__sticky').stop(true, true).fadeOut();
	jQuery('.pc__sticky').stop(true, true).fadeIn();
});

/* FOR MEGA MENU RIGHT */
jQuery(document).ready(function() {

  //jQuery('.menu > ul > li:has( > ul)').addClass('menu-dropdown-icon');
  //Checks if li has sub (ul) and adds class for toggle icon - just an UI

  jQuery('.menu > ul > li > ul:not(:has(ul))').addClass('normal--sub');
  //Checks if drodown menu's li elements have anothere level (ul), if not the dropdown is shown as regular dropdown, not a mega menu (thanks Luka Kladaric)

  //Adds menu-mobile class (for mobile toggle menu) before the normal menu
  //Mobile menu is hidden if width is more then 959px, but normal menu is displayed
  //Normal menu is hidden if width is below 959px, and jquery adds mobile menu
  //Done this way so it can be used with wordpress without any trouble

  jQuery(".mega-right > ul > li").hover(function(e) {
    if (jQuery(window).width() > 943) {
      jQuery(this).children("ul").stop(true, false).fadeToggle(200);
      e.preventDefault();
    }
  });

});
/* FOR MEGA MENU RIGHT */


// DCL Speakers card hover function //
		jQuery( ".dcl__speakers--container" ).mouseenter(function() {
	  		jQuery( ".dcl__speakers--name-ghost" ).hide();
		});

		jQuery( ".dcl__speakers--container" ).mouseleave(function() {
	  		jQuery( ".dcl__speakers--name-ghost" ).fadeIn(200);
		});
// DCL Speakers card hover function //
	
//ProductCraft.com active menu item script
jQuery(document).ready(function () {
    jQuery('.mega-right__item a').on("click", function () {
        jQuery(this).parent().siblings().find("a").removeClass('is__active');
        jQuery(this).addClass('is__active');
    });
});
//ProductCraft.com active menu item script

// Smooth scrolling //
	 // Document ready shorthand statement
    jQuery(function() {
      // Select link by id and add click event
      jQuery('a[href="#theConfArrow"]').click(function() {

        // Animate Scroll to #bottom
       jQuery('html,body').animate({
          scrollTop: jQuery("#theConfArrow").offset().top }, // Tell it to scroll to the top #bottom
          1000 // How long scroll will take in milliseconds
        );

        // Prevent default behavior of link
        return false;
      });
    });
// Smooth scrolling //


// Smooth scrolling //
	 // Document ready shorthand statement
    jQuery(function() {
      // Select link by id and add click event
      jQuery('a[href="#eventinfo--container"]').click(function() {

        // Animate Scroll to #bottom
       jQuery('html,body').animate({
          scrollTop: jQuery("#eventinfo--container").offset().top }, // Tell it to scroll to the top #bottom
          1000 // How long scroll will take in milliseconds
        );

        // Prevent default behavior of link
        e.preventDefault();
      });
    });
// Smooth scrolling //

// Open form //
function openForm() {
	document.getElementById("notifyForm").style.height = "100%";
}
function closeForm() {
    document.getElementById("notifyForm").style.height = "0%";
}
// Open form //

//open nav overlay
function openNav() {
  document.getElementById("eventMenu").style.height = "100%";
}
//close nav overlay
function closeNav() {
  document.getElementById("eventMenu").style.height = "0%";
}
	
	
/*Off canvas menu script */
function openNavLeft() {
    document.getElementById("offCanvas").style.left = "0%";
}

function closeNavLeft() {
    document.getElementById("offCanvas").style.left = "100%";
}
/*Off canvas menu script*/


// Top bar sticky function //
jQuery(function() {
	var nav = jQuery(".conference__topbar--unstick");
	jQuery(window).scroll(function() {
		var scroll = jQuery(window).scrollTop();
		
		if (scroll >= 50) {
			nav.removeClass('conference__topbar--unstick').addClass('conference__topbar--sticky');
		} else {
			nav.removeClass('conference__topbar--sticky').addClass('conference__topbar--unstick');
		}	
	});
});
// Top bar sticky function //

// Custom Scroll Reveal Animations //
var appearXa = {
	delay:1900,
	duration: 500,
	easing : 'cubic-bezier(.75,.13,.31,.7)',
	opacity: .0
}
var appearXb = {
	delay:1500,
	duration: 500,
	easing : 'cubic-bezier(.75,.13,.31,.7)',
	scale : 1.1,
	opacity: .0
}

var fallYa = {
	delay:500,
	duration: 800,
	easing : 'cubic-bezier(.75,.13,.31,.7)',
	distance: '-100px',
	opacity: .0
}
var fallYb = {
	delay:600,
	duration: 800,
	easing : 'cubic-bezier(.75,.13,.31,.7)',
	distance: '-100px',
	opacity: .0
}
var fallYc = {
	delay:700,
	duration: 800,
	easing : 'cubic-bezier(.75,.13,.31,.7)',
	distance: '-100px',
	opacity: .0
}
var fallYd = {
	delay:800,
	duration: 800,
	easing : 'cubic-bezier(.75,.13,.31,.7)',
	distance: '-100px',
	opacity: .0
}

var riseYa = {
	delay: 300,
	duration: 800,
	easing : 'cubic-bezier(.84,.12,.13,.96)',
	distance: '150px',
	opacity: .0
}

var flipXa = {
	delay: 250,
	duration: 600,
	easing : 'cubic-bezier(.75,.13,.31,.6)',
	rotate: {
		x: -90
	}
}
var flipXb = {
	delay: 400,
	duration: 600,
	easing : 'cubic-bezier(.75,.13,.31,.6)',
	rotate: {
		x: -90
	}
}
var flipXc = {
	delay: 250,
	duration: 600,
	easing : 'cubic-bezier(.75,.13,.31,.6)',
	rotate: {
		x: -90
	}
}
var flipXd = {
	delay: 400,
	duration: 600,
	easing : 'cubic-bezier(.75,.13,.31,.6)',
	rotate: {
		x: -90
	}
}

ScrollReveal().reveal('.animate__appear--1', appearXa);
ScrollReveal().reveal('.animate__appear--2', appearXb);

ScrollReveal().reveal('.animate__fall--1', fallYa);
ScrollReveal().reveal('.animate__fall--2', fallYb);
ScrollReveal().reveal('.animate__fall--3', fallYc);
ScrollReveal().reveal('.animate__fall--4', fallYd);

ScrollReveal().reveal('.animate__rise--1', riseYa);

ScrollReveal().reveal('.animate__flip--1', flipXa);
ScrollReveal().reveal('.animate__flip--2', flipXb);
ScrollReveal().reveal('.animate__flip--3', flipXc);
ScrollReveal().reveal('.animate__flip--4', flipXd);
// Custom Scroll Reveal Animations //

/*
jQuery( ".dcl__topbar--registration" ).mouseenter(function() {
	jQuery('.all__events--btn').addClass('on-hover');
});

jQuery( ".dcl__topbar--registration" ).mouseleave(function() {
	jQuery('.all__events--btn').removeClass('on-hover');
});
*/

/*
jQuery(".dcl__topbar--registration").hover(function(e) {
	jQuery('.dcl__date').animate({ left:"20"}, 50);
});

jQuery(".dcl__topbar--registration").mouseleave(function(e) {
	jQuery('.dcl__date').animate({ left:"0"}, 50);
});
*/

/*
jQuery(".dcl__topbar--registration").mouseleave(function(e) {
      jQuery('.all__events--btn').toggle("slide");
	  e.preventDefault();
});
*/

